import "react-multi-carousel/lib/styles.css";
import colorSharp from "../assets/img/color-sharp.png";
import { SkillCard } from "./ExperienceCard";
import ReactJs from "../assets/img/Skills/react.png";
import JavaScript from "../assets/img/Skills/js.png";
import Canva from "../assets/img/Skills/Canva.svg";
import ChartJs from "../assets/img/Skills/Chart.js.png";
import Figma from "../assets/img/Skills/Figma.svg";
import Github from "../assets/img/Skills/github.png";
import Npm from "../assets/img/Skills/Npm.png";
import Angular from "../assets/img/Skills/angular.png";
import AntDesign from "../assets/img/Skills/ant design.png";
import Bootstrap from "../assets/img/Skills/bootstrap.png";
import CSS from "../assets/img/Skills/css3.png";
import Firebase from "../assets/img/Skills/firebase.png";
import GraphQl from "../assets/img/Skills/graphql.png";
import Html from "../assets/img/Skills/html.png";
import Jira from "../assets/img/Skills/jira.svg";
import Mui from "../assets/img/Skills/mui.png";
import Redux from "../assets/img/Skills/redux.svg";
import Sass from "../assets/img/Skills/sass.png";
import Tailwind from "../assets/img/Skills/tailwind.png";
import Typescript from "../assets/img/Skills/typescript.png";
import HeadButton from "./HeadButton";
import React from "react";

export const Skills = () => {
  const skills = [
    { icon: ReactJs, text: "React" },
    { icon: JavaScript, text: "JavaScript" },
    { icon: Canva, text: "Canva" },
    { icon: ChartJs, text: "Chart Js" },
    { icon: Figma, text: "Figma" },
    { icon: Github, text: "Github" },
    { icon: Npm, text: "Npm" },
    { icon: Angular, text: "Angular" },
    { icon: AntDesign, text: "Ant Design" },
    { icon: Bootstrap, text: "Bootstrap" },
    { icon: CSS, text: "CSS3" },
    { icon: Firebase, text: "Firebase" },
    { icon: GraphQl, text: "GraphQl" },
    { icon: Html, text: "Html5" },
    { icon: Jira, text: "Jira" },
    { icon: Mui, text: "Material Ui" },
    { icon: Redux, text: "Redux" },
    { icon: Sass, text: "Sass" },
    { icon: Tailwind, text: "Tailwind" },
    { icon: Typescript, text: "Typescript" },
  ];

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <HeadButton label="Skills" labelFontSize="1.5rem" />
              <marquee>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    paddingTop: "35px",
                  }}
                >
                  {skills.map((skill, index) => (
                    <SkillCard
                      key={index}
                      icon={skill.icon}
                      text={skill.text}
                    />
                  ))}
                </div>
              </marquee>
            </div>
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Image" />
      <hr />
    </section>
  );
};
